export default __webpack_public_path__ + "static/media/bg-hr.c515817d.svg";